import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
export var m = {
  namespaced: true,
  state: {
    info: null,
    prizeList: {},
    winning: {},
    userPrize: {},
    spec: {},
    skuMap: {}
  },
  mutations: {
    setInfo: function setInfo(state, info) {
      state.info = info;
    },
    setPrize: function setPrize(state, _a) {
      var lottery_id = _a.lottery_id,
          list = _a.list;
      Vue.set(state.prizeList, lottery_id, list);
    },
    setWinning: function setWinning(state, _a) {
      var lottery_id = _a.lottery_id,
          list = _a.list;
      Vue.set(state.winning, lottery_id, list);
    },
    setUserPrize: function setUserPrize(state, _a) {
      var lottery_id = _a.lottery_id,
          list = _a.list;
      Vue.set(state.userPrize, lottery_id, list);
    },
    setSpec: function setSpec(state, _a) {
      var id = _a.id,
          spec = _a.spec;
      Vue.set(state.spec, id, spec);
      spec.spec.forEach(function (ele) {
        Vue.set(state.skuMap, ele.id, ele);
      });
    }
  },
  actions: {
    getInfo: function getInfo(_a, activity_id) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var params, res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              params = {};

              if (activity_id) {
                Object.assign(params, {
                  activity_id: activity_id
                });
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/lottery/info', {
                params: params
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setInfo', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getPrize: function getPrize(_a, lottery_id) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/lottery/prize_list', {
                params: {
                  lottery_id: lottery_id
                }
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setPrize', {
                  lottery_id: lottery_id,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    luckyDo: function luckyDo(context, _a) {
      var _b = _a === void 0 ? {} : _a,
          _c = _b.lottery_id,
          lottery_id = _c === void 0 ? null : _c,
          _d = _b.count,
          count = _d === void 0 ? 1 : _d;

      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/lottery/do', {
                params: {
                  lottery_id: lottery_id,
                  count: count
                }
              })];

            case 1:
              res = _e.sent();
              rdata = res.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getWinning: function getWinning(_a, lottery_id) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/lottery/winning', {
                params: {
                  lottery_id: lottery_id,
                  offset: 0,
                  count: 20
                }
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setWinning', {
                  lottery_id: lottery_id,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getUserPrize: function getUserPrize(_a, lottery_id) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/lottery/user_prize', {
                params: {
                  lottery_id: lottery_id
                }
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setUserPrize', {
                  lottery_id: lottery_id,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getSpec: function getSpec(_a, id) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/lottery/spec', {
                params: {
                  id: id
                }
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setSpec', {
                  id: id,
                  spec: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    selectSpec: function selectSpec(_a, params) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/lottery/spec', params)];

            case 1:
              res = _b.sent();
              rdata = res.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};